<table
        (matSortChange)="onSortChange($event)"

        [dataSource]="dataSource"

        mat-table
        matSort
        style="width: 100%"
>
    <!-- <ng-container matColumnDef="action">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
       N°
      </th>
      <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
    </ng-container> -->


    <ng-container matColumnDef="categorie">
        <th *matHeaderCellDef mat-header-cell>

            [ {{ "Identifiant de la classification" | translate }} ] {{ "Nom de la classification" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell width="40%">

            [ {{ d.cateId }} ] {{ d.cateNm }}
        </td>
    </ng-container>


    <ng-container matColumnDef="prodId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "prodId" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell style="text-align: center;">{{ d.prodId }}</td>
    </ng-container>


    <ng-container matColumnDef="prodNm">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ "prodNm" | translate }}
        </th>
        <td *matCellDef="let d" mat-cell>{{ d.prodNm }}</td>
    </ng-container>


    <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let d" mat-cell>
            <a (click)="opendialogannonce(d)" mat-icon-button>
                <mat-icon style="color: #00a8ff;">info</mat-icon>
            </a>

        </td>
    </ng-container>


    <!--  <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">

       <th *matHeaderCellDef mat-header-cell mat-sort-header>
         {{ column | translate }}
       </th>

       <td *matCellDef="let type" mat-cell>
         {{ type[column] | typedValue | async }}
       </td>
     </ng-container> -->
    <tr *matHeaderRowDef="readColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: readColumns" mat-row></tr>


</table>
<app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
